// extracted by mini-css-extract-plugin
export default {"wrapper":"_7f58ece9"};